import { dom, isCompactUi, mqCompactUi } from "../dom";
import { SIDE_RAIL_EXPANDED_KEY, SIDE_RAIL_SECTION_KEY, state } from "../state";
import { onLangChange, t } from "../i18n";
import { trackTool } from "../analytics/events";
import { onSideSectionActivated } from "../ifc/deferredInit";
import { closeIfcAddMenu } from "../ifc/addMenu";

function syncMobileChrome(): void {
  const compact = isCompactUi();
  const showBackdrop = Boolean(compact && state.sideRailExpanded && dom.sideRailBackdrop);
  dom.sideRailBackdrop.classList.toggle("is-visible", showBackdrop);
  dom.sideRailBackdrop.setAttribute("aria-hidden", String(!showBackdrop));
}

export function setActiveSideSection(sectionId: string): void {
  let sid = String(sectionId || "1");
  if (!document.querySelector(`.side-rail-panel[data-panel="${sid}"]`)) {
    sid = "1";
  }
  document.querySelectorAll<HTMLElement>(".side-rail-panel").forEach((panel) => {
    panel.classList.toggle("is-active", panel.dataset.panel === sid);
  });
  document.querySelectorAll<HTMLElement>(".side-rail-icon-btn[data-section]").forEach((btn) => {
    btn.classList.toggle("is-active", btn.dataset.section === sid);
  });
  localStorage.setItem(SIDE_RAIL_SECTION_KEY, sid);
  const sectionTool: Record<string, string> = {
    "1": "section:model",
    "2": "section:selection",
    "3": "section:measure",
    "4": "section:search",
    "5": "section:compare",
    "6": "section:tree",
    "7": "section:visual",
    "8": "section:settings",
  };
  if (sectionTool[sid]) {
    trackTool(sectionTool[sid]);
  }
  onSideSectionActivated(sid);
}

export function applySideRailLayout(): void {
  if (!dom.sideRail || !dom.sideRailToggle) {
    return;
  }
  dom.sideRail.classList.toggle("is-expanded", state.sideRailExpanded);
  dom.sideRail.classList.toggle("is-collapsed", !state.sideRailExpanded);
  dom.sideRailToggle.textContent = state.sideRailExpanded ? "«" : "»";
  dom.sideRailToggle.setAttribute("aria-expanded", String(state.sideRailExpanded));
  dom.sideRailToggle.title = t("sidebar.toggleHint");
  dom.sideRailToggle.setAttribute("aria-label", t("sidebar.toggleHint"));
  document.body.classList.toggle("rail-expanded", state.sideRailExpanded);
  if (state.sideRailExpanded) {
    closeIfcAddMenu();
  }
  syncMobileChrome();
}

export function initSideRail(): void {
  const savedSideRailExpanded = localStorage.getItem(SIDE_RAIL_EXPANDED_KEY);
  state.sideRailExpanded = savedSideRailExpanded !== "0";
  if (savedSideRailExpanded === null && mqCompactUi.matches) {
    state.sideRailExpanded = false;
  }

  dom.sideRailToggle.addEventListener("click", () => {
    state.sideRailExpanded = !state.sideRailExpanded;
    localStorage.setItem(SIDE_RAIL_EXPANDED_KEY, state.sideRailExpanded ? "1" : "0");
    applySideRailLayout();
  });

  dom.sideRailBackdrop.addEventListener("click", () => {
    if (!isCompactUi()) {
      return;
    }
    state.sideRailExpanded = false;
    localStorage.setItem(SIDE_RAIL_EXPANDED_KEY, "0");
    applySideRailLayout();
  });

  mqCompactUi.addEventListener("change", () => {
    syncMobileChrome();
  });

  onLangChange(() => {
    applySideRailLayout();
  });

  document.querySelectorAll<HTMLElement>(".side-rail-icon-btn[data-section]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const sid = btn.dataset.section;
      if (!sid) {
        return;
      }
      if (!state.sideRailExpanded) {
        state.sideRailExpanded = true;
        localStorage.setItem(SIDE_RAIL_EXPANDED_KEY, "1");
        applySideRailLayout();
      }
      setActiveSideSection(sid);
    });
  });
}
